import React from 'react';
import PropTypes from 'prop-types';
import iconColorsMap from './colors';

const Close = ({ fill, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    {...props}
  >
    <path d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4v-2z" />
  </svg>
);
Close.propTypes = { fill: PropTypes.string };
Close.defaultProps = { fill: iconColorsMap.mainicon };

export default Close;
